export const medications = [
  ['Biotin Supplement', '10', '1-0-0'],
  ['Telekast', '10', '0-1-0'],
  ['Lisinopril', '20', '0-0-1'],
  ['Omeprazole', '20', '0-0-1']
];

export const allergies = [
  ['Precocet'],
  ['Crabs'],
  ['Peanuts']
];

export const clinicalFindings = [
  ['Blood Pressure', '120/80'],
  ['Pulse', '78 bpm'],
  ['Respiration', '18/min']
];

export const healthMaintenance = [
  ['Annual Lab', '09/06/2020', 'A1C 6.5, LDL 68'],
  ['Eye Exam', '10/15/2020', 'Normal'],
  ['Dental Checkup', '11/10/2020', 'Completed']
];

export const pastDiagnosis = [
  ['E78.4', 'Other hyperlipidemia'],
  ['K76.0', 'Fatty liver'],
  ['K64.9', 'Unspecified hemorrhoids']
];

export const cpt = [
  ['99213', 'Office visit'],
  ['80053', 'Comprehensive metabolic panel'],
  ['85025', 'CBC with differential']
];

export const vaccinations = [
  ['Influenza', '10/01/2025', 'Completed'],
  ['COVID-19 Booster', '01/15/2026', 'Completed'],
  ['Tetanus', '06/20/2024', 'Completed']
];

export const socialHistory = [
  ['Alcohol', 'Rare'],
  ['Smoking', 'No Smoking'],
  ['Exercise', 'Walking 3 times/week']
];

export const familyHistory = [
  ['Father', 'Diabetes'],
  ['Mother', 'Hypertension'],
  ['Sibling', 'No known problems']
];

export const advanceDirectives = [
  ['Living Will', 'Not on file'],
  ['Power of Attorney', 'Not on file'],
  ['Code Status', 'Full Code']
];

export const sections = [
  {
    title: 'Allergies',
    editable: true,
    rows: allergies,
    backgroundColor: '#F8FBEF'
  },
  {
    title: 'Medications',
    editable: true,
    rows: medications,
    backgroundColor: '#F2FAFE'
  },
  {
    title: 'Clinical Findings',
    rows: clinicalFindings,
    backgroundColor: '#FAFAFA'
  },
  {
    title: 'Health Maintenance',
    editable: true,
    rows: healthMaintenance,
    backgroundColor: '#FFF7F7'
  },
  {
    title: 'Past Diagnosis',
    rows: pastDiagnosis,
    backgroundColor: '#FAFAFA'
  },
  {
    title: 'CPT',
    rows: cpt,
    backgroundColor: '#FAFAFA'
  },
  {
    title: 'Vaccinations',
    editable: true,
    rows: vaccinations,
    backgroundColor: '#F5F8FD'
  },
  {
    title: 'Social History',
    editable: true,
    rows: socialHistory,
    backgroundColor: '#F8FBEF'
  },
  {
    title: 'Family History',
    editable: true,
    rows: familyHistory,
    backgroundColor: '#F4FCFD'
  },
  {
    title: 'Advance Directives',
    editable: true,
    rows: advanceDirectives,
    backgroundColor: '#FCFCFC'
  }
];